import React from "react";

import { Article } from "custom-types/Wordpress";

import BylineImage from "components/news/BylineImage";
import NewsArticleDate from "components/news/NewsArticleDate";

const BrandHeader: React.FC<{
  article: Article;
}> = ({ article }) => {
  const {
    brand: { image, customImage, name, url },
    date,
    modified,
  } = article;

  const validImage = image || customImage;

  return name ? (
    <div className="flex flex-row items-center" data-testid="brand-header">
      {validImage && validImage !== "" && (
        <BylineImage src={validImage} alt={name} className="flex-shrink-0" />
      )}
      <div className="text-sm">
        <span className="block">
          <i className="text-xs">Presented By</i>
          {url ? (
            <a
              className="underline block font-bold"
              href={url}
              rel="sponsored"
              title="Link For Brand Name"
            >
              {name}
            </a>
          ) : (
            <span className="block font-bold">{name}</span>
          )}
        </span>
        <NewsArticleDate date={date} modified={modified} />
      </div>
    </div>
  ) : (
    <></>
  );
};

export default BrandHeader;
